import { render } from "./SouFranqueado.vue?vue&type=template&id=89428ab4&scoped=true"
import script from "./SouFranqueado.vue?vue&type=script&lang=js"
export * from "./SouFranqueado.vue?vue&type=script&lang=js"

import "./SouFranqueado.vue?vue&type=style&index=0&id=89428ab4&scoped=true&lang=css"

import exportComponent from "/home/nathan/Documentos/Creditall/Desenvolvimento/projetos/creditall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89428ab4"]])

export default __exports__